import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MicroFirmlyApprovedComponent } from './micro-firmly-approved/micro-firmly-approved.component';
import { ShowcasesDealsRoutes } from './showcases-deals.routes';

@NgModule({
  declarations: [
    MicroFirmlyApprovedComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ShowcasesDealsRoutes,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class ShowcasesDealsModule { }
